import { Logger } from './logger';
import { rematchStore } from 'models/rematchStore';

export function watcher(fn) {
    return [fn, { type: 'watcher' }];
}

export const checkWebsocketConnection = (rootState) => {
    return new Promise((resolve) => {
        const checkConnection = () => {
            const { connected } = rematchStore.getState().webSocket;
            if (connected) {
                Logger.debug('Websocket connection established');
                resolve();
            } else {
                Logger.debug('Waiting for websocket connection.');
                setTimeout(checkConnection, 100); // Check every 100ms
            }
        };
        checkConnection();
    });
};
